import React, { memo, useContext } from 'react';
import _findIndex from 'lodash/findIndex';
import styled from 'styled-components';

import Checkbox from '@minecraft.minusable-checkbox';
import SelectableDropdownContext from '../SelectableSearchDropdownContext';

const StyledCheckbox = styled(Checkbox)`
  white-space: nowrap;
`;

export type Props = {
  label: string;
  value: string;
  index?: string;
  disabled?: boolean;
};

export default memo(({ label, value, index, disabled = false }: Props) => {
  const { saveAsOption, options, toggleOption, filter, visibilityPredicate } = useContext(SelectableDropdownContext);

  return (
    visibilityPredicate(label, filter, index) && (
      <StyledCheckbox
        label={label}
        data-qa-id={`selectable-dropdown-option-${value}`}
        isChecked={_findIndex(options, (option) => (saveAsOption ? option.value === value : option === value)) !== -1}
        disabled={disabled}
        onChange={(): void => toggleOption(saveAsOption ? { value, label } : value)}
      />
    )
  );
});
